// Le bandeau du haut (horaires + menu) reste collé en haut de l'écran : sans ce
// décalage, le titre de la section visée passerait dessous. Mesuré à chaque
// appel (sa hauteur change entre mobile et desktop) et sans le menu mobile
// déplié, qui se referme au moment du défilement.
//
// Le logo rétrécit dès que la page défile (Nav.vue) : partant du haut de page,
// l'en-tête perd cette hauteur ET le contenu remonte d'autant. Les deux se
// compensent, la hauteur actuelle de l'en-tête reste donc le bon décalage.
const BREATHING = 16

export function headerOffset() {
  const topbar = document.querySelector('.nav__topbar')?.offsetHeight || 0
  const bar = document.querySelector('.nav__bar')?.offsetHeight || 0
  return topbar + bar + BREATHING
}

export function scrollToAnchor(anchor) {
  const el = anchor && document.querySelector(anchor)
  if (!el) return
  const y = el.getBoundingClientRect().top + window.scrollY - headerOffset()
  window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
}
